<template>
    <el-dialog
        title="修改密码"
        append-to-body
        :visible="dialogFormVisible"
        width="600px"
        :close-on-click-modal="false"
        @close="close"
    >
        <el-form ref="form" :model="form" :rules="rules" autocomplete="off">
            <el-form-item
                v-if="info"
                label="用户名："
                prop="name"
                :label-width="formLabelWidth"
            >
                <el-input
                    v-model="info.name"
                    disabled
                    style="width: 90%"
                ></el-input>
            </el-form-item>
            <el-form-item
                v-if="!info"
                label="老密码："
                prop="oldPassword"
                :label-width="formLabelWidth"
            >
                <el-input
                    v-model="form.oldPassword"
                    show-password
                    placeholder="请输入老密码"
                    style="width: 90%"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="新密码："
                prop="newPassword"
                :label-width="formLabelWidth"
            >
                <el-input
                    v-model="form.newPassword"
                    show-password
                    placeholder="请输入新密码"
                    style="width: 90%"
                ></el-input>
                <div class="form-tip">
                    密码要求：至少6位，包含大小写字母、数字和特殊符号
                </div>
            </el-form-item>
            <el-form-item
                label="确认密码："
                prop="cfmPwd"
                :label-width="formLabelWidth"
            >
                <el-input
                    v-model="form.cfmPwd"
                    show-password
                    placeholder="请再输入一遍新密码"
                    style="width: 90%"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { getApplicationCode } from "@/utils/user";
var md5 = require("js-md5");
export default {
    inheritAttrs: false,
    data() {
        return {
            info: null,
            appCode: getApplicationCode(),
            formLabelWidth: "100px",
            dialogFormVisible: false,
            form: {
                oldPassword: null,
                newPassword: null,
                cfmPwd: null,
            },
            rules: {
                oldPassword: [{ required: true, message: "请输入老密码" }],
                newPassword: [{ required: true, message: "请输入新密码" }],
                cfmPwd: [{ required: true, message: "请再输入一遍新密码" }],
            },
        };
    },
    methods: {
        open(data = null) {
            this.info = data;
            this.dialogFormVisible = true;
        },
        close() {
            this.$refs.form.resetFields();
            this.dialogFormVisible = false;
        },
        submit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (this.form.newPassword != this.form.cfmPwd) {
                        this.$alert("确认密码和新密码不一致，请重新输入", {
                            type: "warning",
                        });
                        return;
                    }
                    let url, query;

                    //修改某个用户的密码
                    if (this.info) {
                        url = this.appCode + "/sys/user/reset/password";
                        query = {
                            id: this.info.id,
                            password: md5(this.form.newPassword),
                        };
                    } 
                    //修改自己的密码
                    else {
                        url = this.appCode + "/user/update/me/pwd";
                        query = {
                            oldPassword: md5(this.form.oldPassword),
                            newPassword: md5(this.form.newPassword),
                        };
                    }
                    const res = await this.$store.dispatch("upms/editUserPwd", {
                        url,
                        query,
                    });
                    if (res.state == 1) {
                        this.close();
                        if (!this.info) {
                            this.$message({
                                type: "success",
                                message: "密码修改成功，请重新登录",
                            });
                            setTimeout(() => {
                                this.$store.dispatch("upms/loginOut");
                            }, 2000);
                        } else {
                            this.$message({
                                type: "success",
                                message: "密码修改成功",
                            });
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.form-tip {
    color: #999;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 4px;
}
</style>